import { MouseEvent, ReactElement } from 'react';

interface Props {
  Icon?: HeroIconType;
  IconEnd?: HeroIconType;
  text?: string;
  accentColour: string;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  isSubmit?: boolean;
  disabled?: boolean;
  className?: string;
}

export const AccentButton = ({
  Icon,
  IconEnd,
  text,
  accentColour,
  onClick,
  isSubmit,
  disabled,
  className,
}: Props): ReactElement => (
  <button
    type={isSubmit ? 'submit' : 'button'}
    onClick={onClick}
    disabled={disabled}
    style={disabled ? undefined : { backgroundColor: accentColour }}
    className={`flex items-center justify-center rounded-xs px-3 py-2.5 text-white outline-none disabled:bg-background-disabled disabled:text-disabled-text ${
      className ?? ''
    }`}
  >
    {Icon && <Icon className="size-5 stroke-white" />}
    {text && <span className={Icon ? 'ml-2' : ''}>{text}</span>}
    {IconEnd && <IconEnd className={`size-5 stroke-white ${text || Icon ? 'ml-2' : ''}`} />}
  </button>
);
